type Props = {
  score: number; // 0 ~ 5
  radius?: number; // radius === width / 2
  stroke?: number;
  className?: string;
};

export default function DonutProgress({
  score,
  radius = 64,
  stroke = 10,
  className,
}: Props) {
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;
  const percent = score / 5;
  const strokeDashoffset = circumference * (1 - percent);

  return (
    <svg
      height={radius * 2}
      width={radius * 2}
      className="-rotate-90 transform"
    >
      <circle
        className="stroke-coolgray-20"
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        className={className}
        fill="transparent"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  );
}
